import { isObjectLike, isString, isEmpty, isNull } from 'lodash';
import axios from 'axios';
import config from 'commons-vehicle/config/index.js';
import { LocaleService, ConfigsService, HTTPService } from '@sm360/widget-commons-core-services';
import { AccountService, CookieService, COOKIES } from '@sm360/widget-commons-general';

import { resetTradeInVehicleFromShowroomTradeInVehicle } from 'commons-vehicle/Vehicle/services/TradeInVehicleService/TradeInVehicleService.js';

/**
 * Groups Trade In Vehicle api calls to ShowroomAPI
 */
class TradeInVehicleAPIService {
    constructor() {
        /**
         * The base path for Trade In Vehicle ShowroomAPI
         * @type {string}
         */
        this.basePath = `${config.endpoint.showroom}/service/v1/TradeInVehicle`;
    }

    /**
     * Returns the axios request configuration object to load a Trade In Vehicle Model
     * @param {string} tradeInVehicleId
     */
    getLoadTradeInVehicleRequestConfig(tradeInVehicleId) {
        const requestTradeInVehicleId = isString(tradeInVehicleId) ? tradeInVehicleId : '';
        const orgId = ConfigsService.getOrganizationId();
        const orgUnitId = ConfigsService.getOrganizationUnitId();
        const language = LocaleService.getLocale();
        const location = ConfigsService.getOrganizationUnitLocation();

        const token = CookieService.getToken(COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
        const tradeInVehicleIdParam = requestTradeInVehicleId ? `/${requestTradeInVehicleId}` : '';

        const requestConfig = {
            url: `${this.basePath}${tradeInVehicleIdParam}`,
            method: 'get',
        };

        requestConfig.headers = {
            'x-jwt': isEmpty(token) ? '' : token,
        };

        requestConfig.params = {
            context: `${isNull(orgId) ? '' : orgId}.${isNull(orgUnitId) ? '' : orgUnitId}`,
            language: isEmpty(language) ? '' : language,
            location: isEmpty(location) ? '' : location,
        };

        return requestConfig;
    }

    /**
     * Returns a Trade In Vehicle Model from an id or from the authenticated account
     * @param {string} tradeInVehicleId
     */
    loadTradeInVehicle(tradeInVehicleId) {
        const requestConfig = this.getLoadTradeInVehicleRequestConfig(tradeInVehicleId);
        return axios
            .request(requestConfig)
            .then((result) => resetTradeInVehicleFromShowroomTradeInVehicle(result.data))
            .catch(() => {
                console.error(`Unable to get trade in vehicle for id ${tradeInVehicleId}`);
                return Promise.reject();
            });
    }

    /**
     * Saves a Trade In Vehicle Model back in the showroom database
     * @param {TradeInVehicleModel} tradeInVehicle
     */
    saveTradeInVehicle(tradeInVehicle) {
        if (!tradeInVehicle || !isObjectLike(tradeInVehicle)) {
            return Promise.reject(HTTPService.formatRejectResponse('missing or invalid parameters'));
        } else if (!AccountService.isAuthenticated()) {
            return Promise.reject(HTTPService.formatRejectResponse('user not authenticated'));
        }

        const showroomTradeInVehicle = tradeInVehicle.getShowroomTradeInVehicle();

        return Promise.resolve(showroomTradeInVehicle);
    }
}

export { TradeInVehicleAPIService };
export default new TradeInVehicleAPIService();
